// Composables
import { createRouter, createWebHistory } from 'vue-router'

export default (app) => {
    const setupRoutes = $keycloak => {
        const { isAuthenticated, isLoading } = $keycloak

        return [
            {
                path: '/about',
                name: 'About',
                component: () => import('@/views/About.vue'),
            },{
                path: '/reports',
                name: 'Reports',
                component: () => import('@/views/Reports.vue'),
            },{
                path: '/sb1162',
                name: 'California SB 1162',
                component: () => import('@/views/Sb1162.vue'),
            }, {
                path: '/:catchAll(.*)',
                name: 'catchall',
                component: () => import('@/views/SplashHome.vue')
            },
        ]
    }
    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: setupRoutes(app.config.globalProperties.$keycloak),
        scrollBehavior(to, from, savedPosition) {
            // If the navigation is triggered to the same route (same path)
            if (to.path === from.path) {
                return { x: 0, y: 0 }  // Scroll to the top
            }

            // If there is a savedPosition (back/forward navigation), restore the scroll position
            if (savedPosition) {
                return savedPosition
            }

            // For normal navigation between different routes, don't scroll to the top
            return { top: 0, left: 0 }
        }
    })

    app.use(router)
}
